export const beforeTestMessage = (videoEnabled) => {
  return `For an optimized experience we recommend testing your speakers${videoEnabled ? ',' : ' and'} microphone ${videoEnabled ? 'and camera ' : ''}before starting your reading.`
}
